if (!customElements.get('component-article')) {
  customElements.define('component-article', class Article extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.handleTableOfContentsMobile();
      this.handleVideoGTM();
    }
    handleTableOfContentsMobile() {
      this.querySelector('.js-table-of-contents-mobile').addEventListener('change', event => {
        const option = event.target.options[event.target.selectedIndex];
        window.location.hash = option.dataset.optionAnchor;
      })
    }
    handleVideoGTM() {
      this.querySelectorAll('.js-video').forEach(video => {
        video.addEventListener('play', () => {
          window.sendGTMData && window.sendGTMData({
            event: 'article_video_play',
            article_video_src: video.querySelector('.js-video-source').src
          });
        });
      });
    }
  });
}

if (!customElements.get('component-article-product')) {
  customElements.define('component-article-product', class ArticleProduct extends HTMLElement {
    constructor() {
      super();
      this.state = {
        product: {},
        selectedColor: ''
      }
      this.props = {
        swatches: this.dataset.swatches === 'true',
        productHandle: this.dataset.productHandle,
        parentCollectionHandle: this.dataset.parentCollectionHandle,
        color: this.dataset.color
      }
    }
    async connectedCallback() {
      if (this.props.swatches) {
        this.state.product = await this.getProduct();
        if (this.props.parentCollectionHandle && this.state.product && this.state.product.title != null) {
          this.state.siblingProduct = this.state.product.colors[this.props.color];
          this.render();
        }
      }
      this.handleGTM();
    }
    async getProduct() {
      // Get product data
      let response = await fetch(`${window.Shopify.routes.root}products/${this.props.productHandle}?view=article-product-json`, {
        method: "get"
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      response = await response.json();
      return response;
    }
    render() {
      this.renderSwatches(this);
      this.afterRender();
    }
    renderSwatches(template) {
      if (!this.state.product?.colors) return;
      for (const color in this.state.product.colors) {
        // Prepare color swatch to be added
        const colorTemplate = template.querySelector('.js-template-color').content.cloneNode(true);
        if (window.theme.colors[color]) {
          // Set CSS custom properties for swatch styling
          if (window.theme.colors[color].image) {
            colorTemplate.querySelector('.js-label').style.setProperty('--swatch-image', `url(${window.theme.colors[color].image}`);
          }
          colorTemplate.querySelector('.js-label').style.setProperty('--swatch-color', window.theme.colors[color].color);
          colorTemplate.querySelector('.js-label').style.setProperty('--swatch-border-color', '#fff');
        }
        if (color === this.props.color) {
          colorTemplate.querySelector('.js-input').checked = true;
          colorTemplate.querySelector('.js-color').classList.add("first");
        }
        colorTemplate.querySelector('.js-label').setAttribute('for', `color_${color}_${this.props.id}`);
        colorTemplate.querySelector('.js-label').dataset.color = color;
        colorTemplate.querySelector('.js-input').value = color;
        colorTemplate.querySelector('.js-input').id = `color_${color}_${this.props.id}`;
        this.querySelector('.js-colors').appendChild(colorTemplate);
      }
    }
    afterRender() {
      this.querySelectorAll('.js-colors .js-input').forEach(color => {
        color.addEventListener('change', () => {
          this.state.siblingProduct = this.state.product.colors[color.value];
          this.querySelectorAll('.js-link').forEach(link => {
            link.href = `${this.state.siblingProduct.url}`;
          });
          let img = this.state.siblingProduct.images[0];
          this.querySelector('.js-img').src = img.src;
          this.querySelector('.js-img').srcset = getSrcset(img.src, this.defaultImgSize);
          this.querySelector('.js-price').innerHTML = toMoney(this.state.siblingProduct.price, { no_zeros: true });
          if (this.state.siblingProduct.compare_at_price > this.state.siblingProduct.price) {
            this.querySelector('.js-compare-price').innerHTML = toMoney(this.state.siblingProduct.compare_at_price, { cents: false, no_zeros: true });
          } else {
            this.querySelector('.js-compare-price').innerHTML = '';
          }
        });
      });
    }
    handleGTM() {
      this.querySelectorAll('.js-featured-product').forEach(product => {
        product.addEventListener('click', () => {
          window.sendGTMData && window.sendGTMData({
            event: 'article_product_recommendations',
            product_recommendations_number: product.dataset.num,
            product_recommendations_link: product.href
          });
        });
      });
    }
  });
}
